import React, { useEffect } from "react";
import { Advertorial } from "./pages/Advertorial";
export function App() {
  useEffect(() => {
    // Prevent running twice / already loaded
    if ((window as any).fbq) {
      (window as any).fbq("track", "PageView");
      return;
    }

    // Create fbq stub first (so calls queue safely)
    (window as any).fbq = function () {
      ((window as any).fbq.q = (window as any).fbq.q || []).push(arguments);
    };
    (window as any).fbq.q = [];
    (window as any).fbq.loaded = true;
    (window as any).fbq.version = "2.0";

    // Load the Meta script safely (no parentNode)
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);

    // Init + first page view
    (window as any).fbq("init", "1931716230727203");
    (window as any).fbq("track", "PageView");
  }, []);
  return <Advertorial data-id="element-0" />;
}